<template>

</template>

<script>

export default {
  name: 'Logout',
  data(router) {
    return {
      section: 'Logout',
      loading: '',
      password: '',
      response: '',
      email: ''
    }
  },
  mounted() {
    this.signOut()
  },
  methods: {
    signOut: function() {
      this.$store.commit('SET_TOKEN', null)
      this.$store.commit('SET_USER', null)
      this.$store.dispatch('logoutUser')
      window.localStorage.setItem('token', null)
      window.localStorage.setItem('user', null)
      window.localStorage.setItem('empresa', null)
      window.localStorage.setItem('monitores', null)
      window.localStorage.setItem('monitoramento', null)
      this.$router.push('/login')
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// Logout.vue?73a24994